// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.socialsStatsWrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: 100%;
}
.socialsStatsWrapper .social {
  flex: 1 1 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
}
.socialsStatsWrapper .stats {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  width: 50px;
}
.socialsStatsWrapper .stats span {
  color: #212121;
  font-size: 14px;
  font-weight: 500;
}
.socialsStatsWrapper .stats p {
  margin: 0;
  color: #616161;
  font-size: 12px;
  font-weight: 400;
}
.socialsStatsWrapper .icon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: #d3cfe4;
  padding: 6px;
  box-sizing: content-box;
  margin-right: 16px;
  color: #220d77;
}

.leadsPerMonthGraph {
  border-radius: 6px;
  border-bottom: 1px solid #eee;
  margin-bottom: 16px;
}

.stats {
  display: flex;
  justify-content: space-around;
}
.stats .item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.stats .item p {
  color: #757575;
  font-family: Roboto;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.3px;
  margin: 0;
  margin-bottom: 4px;
}
.stats .item span {
  color: #434243;
  font-size: 20px;
  font-weight: 700;
}

.leadPerCampaing {
  border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/views/Leads/components/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AACF;AAAE;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAEJ;AACE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;AACJ;AAAI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAEN;AAAI;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAEN;AACE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AACJ;;AAGA;EACE,kBAAA;EACA,6BAAA;EACA,mBAAA;AAAF;;AAEA;EACE,aAAA;EACA,6BAAA;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAEJ;AADI;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;AAGN;AADI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAGN;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".socialsStatsWrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  height: 100%;\n  .social {\n    flex: 1 1 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 8px;\n  }\n\n  .stats {\n    display: flex;\n    flex-direction: column;\n    justify-items: center;\n    align-items: center;\n    width: 50px;\n    span {\n      color: #212121;\n      font-size: 14px;\n      font-weight: 500;\n    }\n    p {\n      margin: 0;\n      color: #616161;\n      font-size: 12px;\n      font-weight: 400;\n    }\n  }\n  .icon {\n    width: 24px;\n    height: 24px;\n    border-radius: 6px;\n    background: #d3cfe4;\n    padding: 6px;\n    box-sizing: content-box;\n    margin-right: 16px;\n    color: #220d77;\n  }\n}\n\n.leadsPerMonthGraph {\n  border-radius: 6px;\n  border-bottom: 1px solid #eee;\n  margin-bottom: 16px;\n}\n.stats {\n  display: flex;\n  justify-content: space-around;\n  .item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    p {\n      color: #757575;\n      font-family: Roboto;\n      font-size: 10px;\n      font-weight: 400;\n      letter-spacing: 0.3px;\n      margin: 0;\n      margin-bottom: 4px;\n    }\n    span {\n      color: #434243;\n      font-size: 20px;\n      font-weight: 700;\n    }\n  }\n}\n\n.leadPerCampaing {\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
